import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Route } from '../route';
import { submitter } from '../submitter/submitter';
import { BaseMetric } from './base-metric';
export var Metric = /*#__PURE__*/function (_BaseMetric) {
  _inherits(Metric, _BaseMetric);
  var _super = _createSuper(Metric);
  function Metric() {
    _classCallCheck(this, Metric);
    return _super.apply(this, arguments);
  }
  _createClass(Metric, [{
    key: "start",
    value: function start() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        startTime = _ref.startTime;
      _get(_getPrototypeOf(Metric.prototype), "start", this).call(this, {
        startTime: startTime
      });
      this.route = Route.getRoute();
    }
  }, {
    key: "stop",
    value: function stop() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var stoppedSuccessfully = _get(_getPrototypeOf(Metric.prototype), "stop", this).call(this, params);
      if (stoppedSuccessfully && !this.config.virtual) {
        submitter.queue(this.getData());
      }
      return stoppedSuccessfully;
    }
  }]);
  return Metric;
}(BaseMetric);